module.exports = __webpack_public_path__ + "img/thumb_2021-08.49ac1d6a.jpg";